<script lang="ts">
  import '$lib/styles/app.scss';
  import { onMount } from 'svelte';
  import { goto } from '$app/navigation';
  import { sessionStore } from '$lib/auth/sessionStore.svelte';
  import Toasts from '@components/toasts.svelte';
  import ConfirmHost from '@components/confirmHost.svelte';
  import UnsavedChangesHost from '@components/unsavedChangesHost.svelte';
  import { unsavedChanges } from '$lib/unsavedChanges/unsavedChanges.svelte';

  let { children } = $props();

  onMount(() => {
    // When the token expires, drop the session and bounce to the landing page.
    // An expired token leaves nothing that can be saved, so the unsaved-changes
    // guard must not be able to hold the user on a page whose session is gone.
    sessionStore.onExpire(() => {
      unsavedChanges.allowOnce();
      goto('/');
    });
    // Load any existing session from the cookie and arm the expiry timer.
    sessionStore.hydrate();
  });
</script>

<svelte:head>
  <meta name="theme-color" content="#000000" media="(prefers-color-scheme: dark)" />
  <meta name="theme-color" content="#ffffff" media="(prefers-color-scheme: light)" />

  <link rel="icon" href="/public/favicon.ico" />
  <link rel="icon" type="image/png" sizes="32x32" href="/public/favicon_32x32.png" />
  <link rel="icon" type="image/png" sizes="16x16" href="/public/favicon_16x16.png" />
  <link
    rel="apple-touch-icon"
    type="image/png"
    sizes="180x180"
    href="/public/apple-touch-icon.png"
  />
  <link rel="mask-icon" href="/public/safari-pinned-tab.svg" color="#000000" />

  <meta property="og:title" content="Primal Tsunami Admin" />
  <meta property="og:description" content="News Intelligence Admin" />
  <meta property="og:image" content="/public/link-preview_tsunami.jpg" />
  <meta property="og:url" content="https://tsunami-dev.primal.net" />
  <meta property="primal:git-commit-id" content="XXXXXXXXXXXXX-GIT-COMMIT-ID-XXXXXXXXXXXX" />

  <title>Primal Tsunami Admin</title>
</svelte:head>

{@render children()}

<Toasts />
<ConfirmHost />
<UnsavedChangesHost />
